import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";

const popularLinks = [
  { href: "/book", label: "Book a court" },
  { href: "/pickleball-open-play-brooklyn", label: "Open play in Brooklyn" },
  { href: "/pickleball-lessons-brooklyn", label: "Pickleball lessons" },
  { href: "/events", label: "Private & corporate events" },
  { href: "/pickleball-packages-brooklyn", label: "Packages" },
  { href: "/faqs", label: "FAQs" },
  { href: "/contact", label: "Contact" },
  { href: "/about", label: "About Velto" },
];

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[hsl(var(--velto-beige))] text-[hsl(var(--velto-forest))]">
      <Helmet>
        <title>Page Not Found (404) | Velto Pickleball Club</title>
        <meta name="description" content="The page you're looking for doesn't exist. Explore Velto Pickleball Club — Brooklyn's premier indoor pickleball courts in Red Hook, NYC." />
        <meta name="robots" content="noindex, follow" />
        {/* No canonical: a 404 has no canonical URL, and /404 is not a real
            route. The real 404 status is served by the host (dist/404.html). */}
      </Helmet>

      <Header />

      <main className="pt-banner-6 pb-20">
        <section className="container mx-auto px-4 md:px-6 max-w-3xl text-center">
          <p className="font-sweet-bold font-bold uppercase tracking-wider text-base md:text-lg text-[hsl(var(--velto-copper))] mb-4">
            404 — Page not found
          </p>
          <h1 className="font-instrument text-5xl md:text-6xl leading-[1.05] mb-5">
            We couldn't find that page.
          </h1>
          <p className="font-sweet text-lg md:text-xl text-[hsl(var(--velto-forest))]/80 mb-8 max-w-xl mx-auto">
            The link may be outdated, or the page may have moved. Head back to the
            homepage or pick a popular destination below.
          </p>
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            <Link to="/">
              {/* border-2 border-transparent matches the outlined sibling's
                  border box so the pair renders at the same height. */}
              <Button className="bg-[hsl(var(--velto-copper))] hover:bg-[hsl(var(--velto-copper))]/90 text-white font-sweet-bold uppercase tracking-wider px-8 py-6 text-base border-2 border-transparent">
                Back to Home
              </Button>
            </Link>
            <Link to="/contact">
              <Button
                variant="outline"
                className="bg-transparent border-2 border-[hsl(var(--velto-forest))] text-[hsl(var(--velto-forest))] hover:bg-[hsl(var(--velto-forest))]/10 font-sweet-bold uppercase tracking-wider px-8 py-6 text-base"
              >
                Contact Us
              </Button>
            </Link>
          </div>

          <h2 className="font-instrument text-2xl md:text-3xl mb-5">
            Popular at Velto
          </h2>
          <ul className="grid sm:grid-cols-2 gap-3 text-left">
            {popularLinks.map((l) => (
              <li key={l.href}>
                <Link
                  to={l.href}
                  className="block bg-white/60 hover:bg-white border border-[hsl(var(--velto-forest))]/10 rounded-lg px-4 py-3 font-sweet hover:text-[hsl(var(--velto-copper))] transition-colors"
                >
                  {l.label} →
                </Link>
              </li>
            ))}
          </ul>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
